<template>
  <div>
    <!-- TABELA DE TERMOS -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Termos</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(termo, index) in termos" :key="termo" @contextmenu.prevent="onRightClick($event, termo)" @click="hideMenu()">
                <td data-label="Tipo">{{ termo.tipo }}</td>
                <td>
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="openEdit(termo)">
                      <i class="fa-solid fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>

                    <div class="dropdown-divider"></div>
                    <a :href="'/admin/termos/' + termo.id + '/logs'" class="dropdown-item">
                      <i class="fa-solid fa-bars"></i>
                      &nbsp;&nbsp; Logs
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            id="newMenu"
            style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
            class="dropdown-menu-lg dropdown-menu-right"
          >
            <div class="dropdown-divider"></div>
            <a data-toggle="modal" data-target="#editar-modal" class="dropdown-item">
              <i class="fa-solid fa-pen"></i>
              &nbsp;&nbsp; Editar
            </a>

            <div class="dropdown-divider"></div>
            <a v-if="termo_selecionado" :href="'/admin/termos/' + termo_selecionado.id + '/logs'" class="dropdown-item">
              <i class="fa-solid fa-bars"></i>
              &nbsp;&nbsp; Logs
            </a>
          </div>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + termos.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- EDITAR TERMO -->
    <div class="modal fade" id="editar-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar termo</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Tipo</label>

                  <input readonly="true" class="form-control" v-model="termo_selecionado.tipo" id="conteudo_notificacao" />
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>

                  <Editor
                    class="editor_prime"
                    style="background-color: white"
                    editorStyle="height: 200px;"
                    v-model="formData.conteudo"
                    id="conteudo_notificacao"
                    @text-change="changeText"
                  />
                </div>
              </div>

              <div class="col-sm-12" v-if="termo_selecionado.destinatario == 'user'">
                <div class="form-group">
                  <label for="cco">Cco (valores separados por ;)</label>
                  <textarea name="cco" rows="4" cols="50" style="width: 100%" v-model="formData.cco" @keyup="formatar"></textarea>
                </div>
              </div>

              <div class="col-sm-12" v-if="termo_selecionado.destinatario == 'admin'">
                <div class="form-group">
                  <label for="cco">To</label>
                  <textarea name="cco" rows="4" cols="50" style="width: 100%" v-model="formData.to" @keyup="formatar"></textarea>

                  <span v-if="formData.destinatario == 'admin'" style="color: red" v-for="error in v$.to.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <button @click="update()" class="btn btn-primary btn-sm">
                Salvar
                <i class="fa fa-check"></i>
              </button>

              <button id="fechar_editar" style="margin-left: 15px" data-toggle="modal" data-target="#editar-modal" class="btn btn-danger btn-sm">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import useVueLidate from "@vuelidate/core";

export default {
  props: [""],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      termo_selecionado: "",
      termos: [],
    };
  },

  setup() {
    const formData = reactive({
      conteudo: "",
    });

    const rules = computed(() => {
      let local_rules = {
        conteudo: { required },
      };

      return local_rules;
    });

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.buscarTermos();

    this.total = this.termos.length;
  },

  methods: {
    openEdit(termo) {
      this.termo_selecionado = termo;
      this.selecionartermo(termo);

      document.getElementById("fechar_editar").click();
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, termo) {
      this.termo_selecionado = termo;
      this.selecionartermo(termo);

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    buscarTermos() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Atualizando");
      console.log(data);

      axios
        .post(`/admin/termos/search`, data)
        .then((response) => {
          this.termos = response.data.termos;
          this.total = response.data.total;

          this.pagination(response.data);

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    changeText(textValue) {
      this.formData.corpo_text = textValue.textValue;
    },

    selecionartermo(termo) {
      this.termo_selecionado = termo;
      this.formData.conteudo = termo.conteudo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarTermos();
      }
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    async update() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          id: this.termo_selecionado.id,
          conteudo: this.formData.conteudo,
        };

        console.log("Atualizando");
        console.log(data);

        axios
          .post(`/admin/termos/update`, data)
          .then((response) => {
            let btn = document.getElementById("fechar_editar");

            btn.click();

            this.isLoading = false;

            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Dados atualizados", "/admin/termos");
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarTermos();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
